import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  I18nModule,
  OCC_USER_ID_CURRENT,
  Product,
  TranslationService,
  UrlModule,
  UserIdService,
  WindowRef,
} from '@spartacus/core';
import { StarRatingModule } from '@spartacus/storefront';
import { ProductAddToWishListModule } from '../product-add-to-wish-list/product-add-to-wish-list.module';
import { CollapseListModule } from '../../../../components/collapse-list/collapse-list.module';
import { CollapseItem } from '../../../../components/collapse-list/model/collapse.model';
import { map, Observable, of } from 'rxjs';
import { ScreenViewModule } from '../../../../core/directives/screen-view/_screen-view.module';
import { DEVICE_SIZE } from '../../../../core/models/others.model';
import { CustomAddToCartModule } from '../add-to-cart/add-to-cart.module';
import { CustomItemCounterModule } from '../item-counter/item-counter.module';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ProductPriceModule } from '../product-price/product-price.module';
import { CustomMediaModule } from '../../store-front/misc/media/media.module';
import { ProductCheckInventoryService } from '../product-inventory/product-check-inventory.service';
import { ProductCompareCheckModule } from '../product-comparator-check/product-compare-check.module';
import { fixProductName } from '../../../../core/services/simple-tools';
import { ProductReplacementComponent } from '../product-replacement/product-replacement.component';
import { ProductListItemService } from '../product-list/product-list-item-compact/product-list-item.service';

@Component({
  selector: 'product-row',
  standalone: true,
  imports: [
    CommonModule,
    CustomMediaModule,
    RouterModule,
    UrlModule,
    I18nModule,
    StarRatingModule,
    ProductAddToWishListModule,
    CollapseListModule,
    ScreenViewModule,
    CustomAddToCartModule,
    CustomItemCounterModule,
    ProductPriceModule,
    ProductCompareCheckModule,
    ProductReplacementComponent,
  ],
  templateUrl: './product-row.component.html',
  styleUrl: './product-row.component.scss',
})
export class ProductRowComponent implements OnInit {
  DEVICE_SIZE = DEVICE_SIZE;

  @Input() product!: Product;

  isLogged$ = this.userIdService.getUserId().pipe(map(userID => userID === OCC_USER_ID_CURRENT));
  keyFeatures: CollapseItem[] = [];
  hasStock = Boolean(this.product?.stock?.stockLevelStatus !== 'outOfStock');
  maxQuantity = this.hasStock && this.product?.stock?.stockLevel ? this.product?.stock?.stockLevel : 10000;
  fixProductName = fixProductName;
  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  });

  constructor(
    private userIdService: UserIdService,
    private winref: WindowRef,
    private translationService: TranslationService,
    private productCheckInventoryService: ProductCheckInventoryService,
    private productListItemService: ProductListItemService,
  ) {}

  ngOnInit(): void {
    this.productListItemService.populateFeatures(this.product).then(features => {
      this.keyFeatures = features;
    });
  }

  convertToUntypedFormControl(data: any): UntypedFormControl {
    return data;
  }

  product2Observable(): Observable<Product> {
    return of(this.product);
  }

  productAsObservable(): Observable<Product> {
    return of(this.product);
  }
}
